import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const RESET_FEEDING_TIMES = gql`
mutation ResetFeedingTimes($domain: String!, $lanControllerId: Int!) {
  controller {
    resetFeedingTimes(domain: $domain, lanControllerId: $lanControllerId) {
      code
      success
      message
    }
  }
}
`

export interface ResetFeedingTimesResponse {
	controller: {
		resetFeedingTimes: Def_MutationResponse | null
	}
}

export interface ResetFeedingTimesArgs {
	domain: string;
	lanControllerId: number;
}

